export const DEFAULT_DIPLOMA_LAYOUT = {
  speaker: { x: 50, y: 38, font_size: 26, align: 'center', enabled: true },
  date: { x: 50, y: 48, font_size: 20, align: 'center', enabled: true },
  participant_name: { x: 50, y: 58, font_size: 30, align: 'center', enabled: true },
  diploma_number: { x: 50, y: 68, font_size: 18, align: 'center', enabled: true },
  topic: { x: 50, y: 78, font_size: 18, align: 'center', enabled: false, box_left: 10, box_right: 90, box_bottom: 96 },
};

export const TOPIC_BOX_DEFAULTS = { box_left: 10, box_right: 90, box_bottom: 96, y: 78 };

export const mergeFieldLayout = (raw) => {
  const source = raw && typeof raw === 'object' ? raw : {};
  const merged = {};
  Object.keys(DEFAULT_DIPLOMA_LAYOUT).forEach((key) => {
    merged[key] = { ...DEFAULT_DIPLOMA_LAYOUT[key], ...(source[key] || {}) };
  });
  return merged;
};

export const normalizeTopicCfg = (cfg = {}) => {
  const merged = { ...TOPIC_BOX_DEFAULTS, ...cfg };
  let top = Number(merged.y);
  let bottom = Number(merged.box_bottom);
  let left = Number(merged.box_left);
  let right = Number(merged.box_right);
  if (Number.isNaN(top)) top = TOPIC_BOX_DEFAULTS.y;
  if (Number.isNaN(bottom)) bottom = TOPIC_BOX_DEFAULTS.box_bottom;
  if (Number.isNaN(left)) left = TOPIC_BOX_DEFAULTS.box_left;
  if (Number.isNaN(right)) right = TOPIC_BOX_DEFAULTS.box_right;
  if (right <= left + 3) right = Math.min(98, left + 40);
  if (bottom <= top + 4) bottom = Math.min(98, top + 12);
  return { ...merged, y: top, box_bottom: bottom, box_left: left, box_right: right };
};

export const formatDiplomaDateDisplay = (isoDate) => {
  if (!isoDate) return '';
  const parts = String(isoDate).slice(0, 10).split('-');
  if (parts.length === 3) {
    return `${parts[2]}.${parts[1]}.${parts[0]}`;
  }
  return String(isoDate);
};

export const normalizeParticipantsText = (value) => {
  const names = [];
  String(value || '')
    .split(/\r?\n/)
    .forEach((line) => {
      line
        .replace(/;/g, ',')
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean)
        .forEach((name) => names.push(name));
    });
  return names.join('\n');
};

export const firstParticipantName = (value) => {
  const normalized = normalizeParticipantsText(value);
  const first = normalized.split('\n').find(Boolean);
  return first || 'ФИО участника';
};

export const DIPLOMA_PREVIEW_FONT_SCALE = 0.45;
export const DIPLOMA_PREVIEW_CANVAS_WIDTH = 400;
export const DIPLOMA_FONT_REFERENCE_WIDTH =
  DIPLOMA_PREVIEW_CANVAS_WIDTH / DIPLOMA_PREVIEW_FONT_SCALE;

export const scaledFontSizePx = (fontSize, containerWidth = DIPLOMA_PREVIEW_CANVAS_WIDTH) => {
  const base = Number(fontSize) || 20;
  const width = Number(containerWidth) || DIPLOMA_PREVIEW_CANVAS_WIDTH;
  return Math.max(8, (base * width) / DIPLOMA_FONT_REFERENCE_WIDTH);
};

export const previewFontSize = (fontSize, containerWidth = DIPLOMA_PREVIEW_CANVAS_WIDTH) =>
  `${scaledFontSizePx(fontSize, containerWidth)}px`;
